import { Col, Row } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getHealthStates,
  getSponsorshipAmounts,
  getUnsponsoredOrphans,
} from "../../../../../apis/actions/sponsor.actions";
import { AppDispatch, RootState } from "../../../../../apis/store";
import PrimaryButton from "../../../../../biblio/Buttons/PrimaryButton";
import DotsLoader from "../../../../../biblio/Loader/DotsLoader";
import ModalComponent from "../../../../../biblio/Modal/ModalComponent";
import PaginationComponent from "../../../../../biblio/Pagination/PaginationComponent";
import Selects from "../../../../../biblio/Selects/Selects";
import {
  scroll,
  showNotitfication,
} from "../../../../../components/utils/utils";
import SponsorResult from "../SponsorResult";
import { sponsorshipType, switchOptions } from "../utils";
import AllUnsponsoredOrphansWidows from "./AllUnsponsoredOrphansWidows";
import UnsponsoredOrphansCollapse from "./UnsponsoredOrphansCollapse";
import { options } from "../../../../../data/OrphansData";
import RenewSponsorShip from "../renewSponsorship/RenewSponsorShip";

interface Props {
  orphans: any[];
  type: "sponsored" | "unsponsored";
}
const OrphansSponsorshipOverview = ({ orphans, type }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    dispatch(getHealthStates());
    dispatch(getSponsorshipAmounts());
  }, [dispatch]);
  const [selectedFilter, setSelectedFilter] = useState<any>(null);
  const [selectedType, setSelectedType] = useState<any>("");
  const [selectedFilterType, setSelectedFilterType] = useState<any>(null);
  const [selectedCategory, setSelectedCategory] = useState<any>("");
  const [selectedItems, setSelctedItems] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const { loading, healthStates } = useSelector(
    (state: RootState) => state?.sponsor
  );
  const {
    sponsorDetails,
    unsponsoredOrphans,
    TotalUnsponsored,
  } = useSelector((state: RootState) => state?.sponsor);
  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  const itemPerPage = 8;

  useEffect(() => {
    setSelctedItems([]);
    setSelectedType(null);
  }, [type]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(
          getUnsponsoredOrphans({
            limit: itemPerPage,
            page: currentPage,
            beneficiary_type: selectedCategory,
            sponsorship_type: selectedType,
            health_state_id: selectedFilter,
          })
        );
      } catch (error) {
        console.error("Failed to fetch orphans:", error);
      }
    };
    fetchData();
  }, [
    dispatch,
    currentPage,
    selectedType,
    selectedCategory,
    selectedFilter,
    itemPerPage,
  ]);

  const handleSelectTypeChange = (value: any) => {
    if (value) {
      setSelectedType(value?.value);

      if (value.value === "main") {
        setSelectedFilterType(2);
      } else if (value.value === "support") {
        setSelectedFilterType(1);
      } else if (value.value === "widow") {
        setSelectedFilterType(4);
      } else if (value.value === "main_support") {
        setSelectedFilterType(3);
      }
    } else {
      setSelectedType(null);
      setSelectedFilterType(null); 
    }
    setCurrentPage(1);
  };
  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(value.value);
    } else {
      setSelectedFilter(null);
    }
    setCurrentPage(1);
  };
  const handleSelectCategoryChange = (value: any) => {
    if (value) {
      if (value.label === "أرملة") {
        setSelectedCategory("mother");
        setSelectedType("widow");
      } else if (value.label === "يتيم(ة)") {
        setSelectedCategory(["son", "daughter"]);
        setSelectedType("main");
      } else if (value.label === "الإثنين معاً") {
        setSelectedCategory(["mother", "son", "daughter"]);
        setSelectedType(null);
      } else {
        setSelectedCategory(null);
        setSelectedType(null);
      }
    } else {
      setSelectedCategory(null);
      setSelectedType(null);
    }
    setCurrentPage(1);
  };
  const toAddOrRemoveItem = (item: any) => {
    const index = selectedItems.findIndex((i: any) => i.id === item.id);
    const list = [...selectedItems];
    if (index === -1 && type === "unsponsored") {
      if (sponsorDetails?.overdue_amount > 0) {
        return showNotitfication(
          "لا يمكن إضافة كفالة جديدة إلا بعد تسوية جميع المتأخرات",
          "error"
        );
      }

      if (sponsorDetails?.cancelled_booking === true) {
        return showNotitfication(
          "لقد تجاوزت عدد الإلغاءات المسموح بها. يرجى إضافة مبلغ إلى المحفظة للسماح لك بطلب كفالة",
          "error"
        );
      }
      if (sponsorDetails?.unpaid_booking_number > 0) {
        return showNotitfication(
          "لا يمكنك تقديم طلب كفالة جديدة نظرًا لوجود طلب سابق غير مدفوع",
          "error"
        );
      }
      /*
      if (
        sponsorDetails?.surplus_amount < totalAmount &&
        selectedItems?.length >= sponsorshipAmount?.number_orphans_reserved
      ) {
        return showNotitfication(
          `لا يمكنك حجز أكثر من ${sponsorshipAmount?.number_orphans_reserved} في المرة الواحدة`,
          "error"
        );
      }
      if (
        sponsorDetails?.surplus_amount < totalAmount &&
        sponsorDetails?.surplus_amount > 0
      ) {
        return showNotitfication("لا يمكن إضافة كفالة جديدة", "error");
      }
      */
    }
    if (index !== -1) {
      list.splice(index, 1);
      setSelctedItems([...list]);
    } else {
      item.month = 1;
      item.amount = item.sponnsorShipAmount;
      setSelctedItems([...list, item]);
    }
  };

  const handleChange = (items: any[]) => {
    const list: any[] = [];
    selectedItems.forEach((el) => {
      const index = unsponsoredOrphans.findIndex((i: any) => i.id === el.id);
      // eslint-disable-next-line eqeqeq
      if (index == -1) list.push(el);
    });
    selectedItems.forEach((el) => {
      const index = items.findIndex((i: any) => i.id === el.id);
      if (index !== -1) list.push(items[index]);
    });
    setSelctedItems(list);
  };
  return (
    <>
      <Row gutter={8} dir="rtl" style={{ marginBottom: "1.5rem" }}>
        <Col
          xxl={type === "unsponsored" ? 12 : 20}
          xl={type === "unsponsored" ? 11 : 19}
          lg={type === "unsponsored" ? 12 : 20}
          md={type === "unsponsored" ? 12 : 20}
          sm={24}
          xs={24}
        >
          <span className="takaful--service-section-title">
            {type === "unsponsored" ? "إضافة يتيم جديد" : "تجديد كفالاتي"}
          </span>
        </Col>
        {type === "unsponsored" && (
          <Col
            xxl={4}
            xl={4}
            lg={4}
            md={4}
            sm={type === "unsponsored" ? 12 : 24}
            xs={type === "unsponsored" ? 12 : 24}
          >
            <Selects
              options={options}
              selectPlaceholder="نوع المستفيد"
              onChange={handleSelectCategoryChange}
              allowClear={true}
              className="takaful--service-select takaful--request-select"
              popupClassName="takaful--service-select-dropdown"
            />
          </Col>
        )}
        <Col
          xxl={4}
          xl={4}
          lg={4}
          md={4}
          sm={type === "unsponsored" ? 12 : 24}
          xs={type === "unsponsored" ? 12 : 24}
        >
          <Selects
            options={
              type === "unsponsored" && selectedCategory
                ? switchOptions(selectedCategory)
                : sponsorshipType
            }
            value={
              type === "unsponsored" && selectedCategory === "أرملة"
                ? "أرملة"
                : selectedType
            }
            selectPlaceholder="نوع الكفالة"
            onChange={handleSelectTypeChange}
            allowClear={true}
            className="takaful--service-select takaful--request-select"
            popupClassName="takaful--service-select-dropdown"
          />
        </Col>
        {type === "unsponsored" && (
          <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
            <Selects
              options={healthStates}
              selectPlaceholder="الحالة صحية"
              onChange={handleSelectChange}
              allowClear={true}
              className="takaful--service-select takaful--request-select takaful--health-select-design"
              popupClassName="takaful--service-select-dropdown"
            />
          </Col>
        )}
      </Row>
      {type === "sponsored" && (
        <div className="takaful--renew-sponsorship-container-btn">
          <PrimaryButton
            onClick={() => {
              setModalVisible(true);
              setSelctedItems([]);
            }}
            title="تجديد كفالة كل أيتامي و أراملي"
            className="takaful--add-request-btn takaful--renew-sponsorship-btn"
          />
        </div>
      )}
      <SponsorResult title="" items={selectedItems} />
      {loading ? (
        <div className="takaful--loading-projects-cases">
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : unsponsoredOrphans?.length === 0 &&
        !selectedFilter &&
        !selectedCategory &&
        !selectedType ? (
        <p className="takaful--no-services">لا توجد كفالات</p>
      ) : unsponsoredOrphans?.length === 0 &&
        (selectedFilter || selectedCategory || selectedType) ? (
        <p className="takaful--no-services">
          لا يوجد كفالات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row
            justify={"space-around"}
            ref={currentRef}
            style={{ marginTop: "2rem" }}
          >
            <UnsponsoredOrphansCollapse
              unsponsoredOrphans={unsponsoredOrphans}
              addOrRemoveItem={(e) => toAddOrRemoveItem(e)}
              selectedItems={selectedItems}
              handleChange={(l) => handleChange(l)}
              itemPerPage={itemPerPage}
              currentPage={currentPage}
              type={type}
              surplus_amount={sponsorDetails?.surplus_amount}
              filter_type={selectedFilterType}
            />
          </Row>

          <div className="takaful--pagination-container">
            {unsponsoredOrphans &&
              Math.ceil(TotalUnsponsored * itemPerPage) > itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalUnsponsored * itemPerPage)}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
          {selectedItems?.length > 0 && (
            <Row
              justify={"end"}
              dir="rtl"
              className="takaful--request-col-space"
            >
              <Col xxl={4} xl={4} lg={6} md={6} sm={8} xs={8}>
                <PrimaryButton
                  onClick={() => setIsModalVisible(true)}
                  title="إعتماد"
                  className="takaful--sponsor-orphan-card-button"
                />
              </Col>
            </Row>
          )}
        </>
      )}
      <ModalComponent
        title=""
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        closeOnOutsideClick={true}
        width={1200}
        modalStyle={{ top: 150 }}
      >
        <AllUnsponsoredOrphansWidows
          selectedItems={selectedItems}
          setSelctedItems={setSelctedItems}
          addOrRemoveItem={(e) => toAddOrRemoveItem(e)}
          openModal={(v) => setIsModalVisible(v)}
          type={type}
          surplus_amount={sponsorDetails?.surplus_amount}
        />
      </ModalComponent>
      <RenewSponsorShip
        visible={modalVisible}
        setVisible={setModalVisible}
        orphans={unsponsoredOrphans}
      />
    </>
  );
};

export default OrphansSponsorshipOverview;
